export function createResolverPlugin(plugin) {
    return plugin;
}
